<script setup lang="ts">
import { Separator } from '@collector/shared-ui'
import {
  EventScoutRank,
  type EventScout,
} from '@collector/sportsapi-client-legacy'

import ScoutDisplayName from './ScoutDisplayName.vue'

defineProps<{
  eventScouts: EventScout[]
}>()
</script>

<template>
  <div class="flex text-xs">
    <ScoutDisplayName
      label="1st scout:"
      :rank="EventScoutRank.Main"
      :eventScouts
    />

    <Separator
      class="mx-1.5"
      vertical
    />

    <ScoutDisplayName
      label="2nd scout:"
      :rank="EventScoutRank.Helper"
      :eventScouts
    />
  </div>
</template>
